<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent: 00em;">A huge thank you to Austin Macauley Publishers for their patience, understanding, assistance and belief.</p><br/>
<p style="text-indent: 00em;">Thank you to Arie Hong for providing amazing illustrations, not only an intricate and gorgeously detailed sketch of the necklace, but the front and back covers as well.</p><br/>
<p style="text-indent: 00em;">Finally, thank you to all those who were part of this arduous process and bringing the manuscript to fruition.</p><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?b15220e0